import { Price } from '@core/type';

/* eslint-disable-next-line @typescript-eslint/no-magic-numbers */
export const roundPrice = (price: Price) => Math.round(price * 100) / 100;
